define('lib/Podio.Transport.Apps',['require','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Config'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var podioConfig = require('lib/Podio.Config');

  /* Layouts */
  function getAddAppModalLayout(callback) {
    var url = routes.add_app_modal_apps_with_current_space_path();
    transport.getJSON(url, {}, callback);
  }

  function getShareAppModalLayout(appId, callback) {
    var url = routes.json_share_app_modal_path();
    transport.getJSON(url, { requestData : {app_id: appId, org_slug: podioConfig.orgSlug}}, callback);
  }

  function update_order(appIds, callback) {
    //var url = make_absolute_url('apps/update-order');
    var url = routes.update_order_apps_with_current_space_path();
    transport.postJSON(url, { requestData : {app_ids: appIds }}, callback);
  }

  function getAppShareExtrasLayout(appId, callback) {
    var url = routes.json_share_app_extras_path(appId);
    transport.getJSON(url, {}, callback);
  }

  function getAppShareDependenciesLayout(appId, callback) {
    var url = routes.json_share_app_dependencies_path(appId);
    transport.getJSON(url, {}, callback);
  }

  return {
    getAddAppModalLayout: getAddAppModalLayout,
    getShareAppModalLayout: getShareAppModalLayout,
    update_order: update_order,
    getAppShareExtrasLayout: getAppShareExtrasLayout,
    getAppShareDependenciesLayout: getAppShareDependenciesLayout
  };

});

